export function formatEnumString(t: string): string {
  if (t.includes("__")) {
    return t.replace("__", ", ");
  } else if (t.includes("_")) {
    return t.replace(new RegExp("_", "g"), " ");
  }

  return t;
}



// WEBPACK FOOTER //
// ./src/pipes/pipe-enum-utils.ts